import type {
  ExonnHubCheckboxFilterModel,
  ExonnHubFilterModel,
  ExonnHubRangeFilterModel,
} from "./ExonnHub.types.ts";

export const isRangeFilterModel = (
  filter: ExonnHubFilterModel,
): filter is ExonnHubRangeFilterModel => filter.type === "range";
export const isCheckboxFilterModel = (
  filter: ExonnHubFilterModel,
): filter is ExonnHubCheckboxFilterModel => filter.type === "checkbox";
